import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Logo from "../../Assets/writeme.png";

const Navbar = () => {
  const userToken = JSON.parse(localStorage.getItem("WM:user-token"));
  const [navbar, setNavbar] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("WM:user-token");
    toast.success("Signed out successfully");
    navigate("/signin");
  };
  return (
    <>
      <nav className="w-full bg-cyan-600 shadow">
        <div className="justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8">
          <div>
            <div className="flex items-center justify-between py-3 md:py-3 md:block">
              <Link to="/">
                <img src={Logo} className="w-8 h-8" alt="writeme-logo" />
              </Link>
              <div className="md:hidden">
                <button
                  className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                  onClick={() => setNavbar(!navbar)}
                >
                  {navbar ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 text-white"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>
          <div>
            <div
              className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${
                navbar ? "block" : "hidden"
              }`}
            >
              <ul className="items-center justify-center space-y-8 md:flex md:space-x-6 md:space-y-0">
                <li className="text-white hover:text-indigo-200">
                  <Link to="/">Home</Link>
                </li>
                <li className="text-white hover:text-indigo-200">
                  <Link to="/blogs">Blogs</Link>
                </li>
              </ul>

              {userToken ? (
                <div className="mt-3 space-y-2  md:hidden">
                  <Link
                    to="/write-blog"
                    className="inline-block w-full px-4 py-2 text-center text-white bg-indigo-600 rounded-md shadow hover:bg-indigo-500"
                  >
                    <i className="fa-solid fa-pen-nib"></i> Write
                  </Link>
                  <Link
                    to="/profile"
                    className="inline-block w-full px-4 py-2 text-center text-white bg-green-600 rounded-md shadow hover:bg-green-500"
                  >
                    <i className="fa-solid fa-user"></i> Profile
                  </Link>

                  <button
                    onClick={handleLogout}
                    className="inline-block w-full px-4 py-2 text-center text-white bg-red-600 rounded-md shadow hover:bg-red-500"
                  >
                    <i className="fa-solid fa-arrow-left"></i> Sign Out
                  </button>
                </div>
              ) : (
                <div className="mt-3 space-y-2  md:hidden">
                  <Link
                    to="/"
                    className="inline-block w-full px-4 py-2 text-center text-white bg-gray-600 rounded-md shadow hover:bg-gray-800"
                  >
                    Sign in
                  </Link>
                  <Link
                    to="/"
                    className="inline-block w-full px-4 py-2 text-center text-gray-800 bg-white rounded-md shadow hover:bg-gray-100"
                  >
                    Sign up
                  </Link>
                </div>
              )}
            </div>
          </div>
          {userToken ? (
            <div className="hidden space-x-2 md:inline-block">
              <Link
                to="/write-blog"
                className="px-4 py-2 text-white bg-indigo-600 rounded-md shadow hover:bg-indigo-500"
              >
                <i className="fa-solid fa-pen-nib"></i> Write
              </Link>
              <Link
                to="/profile"
                className="px-4 py-2 text-white bg-green-600 rounded-md shadow hover:bg-green-500"
              >
                <i className="fa-solid fa-user"></i> Profile
              </Link>
              <button
                onClick={handleLogout}
                className="px-4 py-2 text-white bg-red-500 rounded-md shadow hover:bg-red-600"
              >
                <i className="fa-solid fa-arrow-left"></i> Sign Out
              </button>
            </div>
          ) : (
            <div className="hidden space-x-2 md:inline-block">
              <Link
                to="/signin"
                className="px-4 py-2 text-white bg-gray-600 rounded-md shadow hover:bg-gray-800"
              >
                <i className="fa-solid fa-arrow-right"></i> Sign in
              </Link>
              <Link
                to="/signup"
                className="px-4 py-2 text-gray-800 bg-white rounded-md shadow hover:bg-gray-100"
              >
                <i className="fa-solid fa-right-to-bracket"></i> Sign up
              </Link>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
